module.exports = __webpack_public_path__ + "img/bots-and-beasts--what-makes-machines--animals--and-people-smart--cover.a7f510a9.jpg";